module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '\n<div>\n';

const toHref = ( url ) => {
    if ( String( url ).startsWith( 'www' ) ) {
        return 'https://' + url;
    }
    return url;
};

regulations.forEach( (regulation) => {
    const {
        HW_EU_NIEDERLA,
        HERSTELLER,
        STRASSE,
        LIEF_LANDBEZ3,
        PLZ_ORT,
        EMAIL_ADRESSE_128,
        HOMEPAGE,
        TELEFONNUMMER1
    } = regulation;

    const data = [{
        'head': 'Hersteller:',
        'rows': [
            HERSTELLER,
            STRASSE,
            [LIEF_LANDBEZ3, PLZ_ORT].filter( Boolean ).join( ' - ' ),
            [
                EMAIL_ADRESSE_128 && `<a href="mailto:${EMAIL_ADRESSE_128}">${EMAIL_ADRESSE_128}</a>`,
                HOMEPAGE && `<a href="${toHref(HOMEPAGE)}" target="_blank">${HOMEPAGE}</a>`
            ].filter( Boolean ).join( ', ' ),
            TELEFONNUMMER1 && `<a href="tel:${TELEFONNUMMER1}">${TELEFONNUMMER1}</a>`,
        ],
    }];
    if ( 'N' === regulation.HW_EU_NIEDERLA ) {
        const {
            HERSTELLER_2,
            STRASSE_2,
            LIEF_LANDBEZ3_2,
            PLZ_ORT_2,
            EMAIL_ADRESSE128_2,
            HOMEPAGE_2,
            TELEFONNUMMER2
        } = regulation;

        data.push({
            'head': 'Verantwortliche Person:',
            'rows': [
                HERSTELLER_2,
                STRASSE_2,
                [LIEF_LANDBEZ3_2, PLZ_ORT_2].filter( Boolean ).join( ' - ' ),
                [
                    EMAIL_ADRESSE128_2 && `<a href="mailto:${EMAIL_ADRESSE128_2}">${EMAIL_ADRESSE128_2}</a>`,
                    HOMEPAGE_2 && `<a href="${toHref(HOMEPAGE_2)}" target="_blank">${HOMEPAGE_2}</a>`
                ].filter( Boolean ).join( ', ' ),
                TELEFONNUMMER2 && `<a href="tel:${TELEFONNUMMER2}">${TELEFONNUMMER2}</a>`,
            ],
        });
    }
    ;
__p += '\n    ';
 data.forEach( ({head,rows}) => { ;
__p += '\n        <p>\n            <strong>' +
((__t = ( head )) == null ? '' : __t) +
'</strong><br />\n            ' +
((__t = ( rows.filter( Boolean ).join( '<br/>' ) )) == null ? '' : __t) +
'\n        </p>\n    ';
 } ) ;
__p += '\n\n';
 } ); ;
__p += '\n</div>\n';

}
return __p
};
